import React from 'react';
import styles from '../../styles/UltimatePage.module.css';

const CustomPage = () => {
  return (
    <div className={styles.clientContainer}>
      <h1>Custom Plan</h1>
      <p>This is a fully customizable plan tailored to your needs.</p>
      <p>Contact us to create a custom plan for your trucking business.</p>
    </div>
  );
};

export default CustomPage;
